<div class="container">
  <div class="title-wrap">
    <h1 class="title">{{ 'pages.chains.title' | translate }}</h1>
    <div class="actions" *ngIf="editable">
      <button class="btn btn__primary btn__icon" *ngIf="isEdited" (click)="openAddChain()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 1V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
          <path d="M0.999878 8H14.9999" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        </svg>
        <span class="add">{{ 'pages.chains.actions.add' | translate }}</span>
      </button>
      <button class="btn btn__icon" [ngClass]="{'btn__secondary': !isEdited, 'btn__active': isEdited}" (click)="isEdited = !isEdited">
        <span *ngIf="!isEdited">{{ 'pages.chains.actions.manage' | translate }}</span>
        <span *ngIf="isEdited">{{ 'pages.chains.actions.done' | translate }}</span>
      </button>
    </div>
  </div>
  <div class="chains-list">
    <div class="chains-list__item" *ngFor="let chain of allChains"
         [routerLink]="['/chains', chain.id, 'restaurants']"
    >
      <div class="item-column">{{chain.name}}</div>
      <div class="item-column">{{chain.email}}</div>

    </div>
  </div>
</div>
